"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PROJECT_COLLABORATORS = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_PROJECT_COLLABORATORS = (0, gql_1.gql)(`
  query ProjectCollaborators($ids: [ID!]) {
    projects(ids: $ids) {
      edges {
        node {
          collaborators {
            edges {
              node {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`);
